/* ===========================================================
   Elite Supplements — Store Detail Page
   Hours, rating, review count and reviews are rendered server-side by
   sections/store-detail.liquid from the cached Google Places data in the
   store's api_data metaobject field (see /store-sync). This file only
   handles what genuinely has to run in the browser:
     1. Live open/closed status + "is today" row highlight, computed from
        data already embedded in the page (periods + utc_offset) — plain
        date math, no API call of any kind.
     2. The branded, interactive pin map (drag/pan/zoom for navigation) via
        the Maps JavaScript API — see snippets/sd-store-map.liquid. This is
        a live Google API call on every store detail page view.
   =========================================================== */
(function () {
  'use strict';

  var GMAPS_KEY = 'AIzaSyDAbHXBou1xv2JlR-nvOjxSSgb5TN7F9JI';

  var page = document.getElementById('store-page');
  if (!page) return;
  var mapEls = page.querySelectorAll('.es-jsmap');

  /* ---------- Open/closed status: pure local date math, no API call ---------- */

  function toMinutes(t) { return parseInt(t.substr(0, 2), 10) * 60 + parseInt(t.substr(2, 2), 10); }

  // 540 -> "9:00 AM"
  function fmtMins(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    var ap = h >= 12 ? 'PM' : 'AM';
    var hh = h % 12; if (hh === 0) hh = 12;
    return hh + ':' + (m < 10 ? '0' + m : m) + ' ' + ap;
  }

  // period.open/close = { day: 0-6 (Sun-Sat), time: "0900" }, in the store's local time
  function isOpenAt(periods, day, minutesNow) {
    for (var i = 0; i < periods.length; i++) {
      var p = periods[i];
      if (!p.open) continue;
      var openDay = p.open.day;
      var openMin = toMinutes(p.open.time);
      var hasClose = !!p.close;
      var closeDay = hasClose ? p.close.day : openDay;
      var closeMin = hasClose ? toMinutes(p.close.time) : 24 * 60;

      if (openDay === day) {
        if (closeDay === openDay) {
          if (minutesNow >= openMin && minutesNow < closeMin) return true;
        } else if (minutesNow >= openMin) {
          return true; // crosses midnight forward into tomorrow
        }
      } else if (closeDay === day && closeDay !== openDay) {
        if (minutesNow < closeMin) return true; // opened the day before, still open
      }
    }
    return false;
  }

  function nextOpening(periods, day, minutesNow) {
    var dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    for (var offset = 0; offset < 8; offset++) {
      var checkDay = (day + offset) % 7;
      var best = null;
      for (var i = 0; i < periods.length; i++) {
        var p = periods[i];
        if (!p.open || p.open.day !== checkDay) continue;
        var mins = toMinutes(p.open.time);
        if (offset === 0 && mins <= minutesNow) continue;
        if (best === null || mins < best) best = mins;
      }
      if (best !== null) {
        var when = offset === 0 ? 'today' : offset === 1 ? 'tomorrow' : dayNames[checkDay];
        return { when: when, time: fmtMins(best) };
      }
    }
    return null;
  }

  function applyStoreStatus() {
    var periodsEl = document.getElementById('store-hours-periods');
    if (!periodsEl) return;

    var periods;
    try { periods = JSON.parse(periodsEl.textContent || 'null'); } catch (e) { periods = null; }
    if (!periods || !periods.length) return;

    var offsetRaw = page.getAttribute('data-utc-offset');
    var utcOffset = offsetRaw ? parseInt(offsetRaw, 10) : NaN;
    if (isNaN(utcOffset)) return;

    var local = new Date(Date.now() + utcOffset * 60000);
    var day = local.getUTCDay();
    var minutesNow = local.getUTCHours() * 60 + local.getUTCMinutes();
    var open = isOpenAt(periods, day, minutesNow);

    page.querySelectorAll('[data-place-status]').forEach(function (el) {
      el.className = open ? 'status status--open' : 'status status--closed';
      el.innerHTML = open ? '<span class="dot"></span>Open now' : '<span class="dot"></span>Closed';
    });

    var labelText;
    if (open) {
      labelText = 'Open now';
    } else {
      var next = nextOpening(periods, day, minutesNow);
      labelText = next ? 'Opens ' + next.when + ' at ' + next.time : 'Closed';
    }
    page.querySelectorAll('[data-place-statuslabel]').forEach(function (el) { el.textContent = labelText; });

    page.querySelectorAll('.hours-row').forEach(function (row) {
      row.classList.toggle('is-today', String(day) === row.getAttribute('data-day'));
    });
  }

  /* ---------- Branded JS maps (replace the embed iframes) ---------- */
  function loadMaps(cb) {
    if (window.google && window.google.maps) { cb(); return; }
    if (window.__esMapsLoading) {
      var t = setInterval(function () {
        if (window.google && window.google.maps) { clearInterval(t); cb(); }
      }, 120);
      return;
    }
    window.__esMapsLoading = true;
    window.__esMapsReady = function () { cb(); };
    var s = document.createElement('script');
    s.src = 'https://maps.googleapis.com/maps/api/js?key=' + GMAPS_KEY + '&callback=__esMapsReady&loading=async';
    s.async = true;
    document.head.appendChild(s);
  }

  function renderMaps() {
    if (!mapEls.length) return;
    var lat = parseFloat(page.getAttribute('data-lat'));
    var lng = parseFloat(page.getAttribute('data-lng'));
    if (!isFinite(lat) || !isFinite(lng)) return;
    var pos = { lat: lat, lng: lng };
    var PIN = {
      url: 'https://elitesupps.com.au/cdn/shop/files/map-pin.svg?v=1780910073',
      scaledSize: new google.maps.Size(40, 51), // 120x152 SVG ratio
      anchor: new google.maps.Point(20, 51)      // tip at bottom-centre
    };
    mapEls.forEach(function (el) {
      var zoom = parseInt(el.getAttribute('data-zoom'), 10) || 16;
      var map = new google.maps.Map(el, {
        center: pos, zoom: zoom,
        mapTypeControl: false, streetViewControl: false, fullscreenControl: true,
        gestureHandling: 'cooperative'
      });
      new google.maps.Marker({ position: pos, map: map, icon: PIN, title: el.getAttribute('data-title') || '' });
    });
  }

  applyStoreStatus();
  if (mapEls.length) loadMaps(renderMaps);
})();
